import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "d-flex flex-stack" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-5" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = {
  class: "d-flex flex-row border-1 pt-5 px-3",
  style: {"margin-left":"30px","margin-right":"30px","border-style":"solid !important","margin-bottom":"10px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-3 px-3",
  style: {"font-size":"larger","font-weight":"500","margin-top":"5px"}
}, " Rangkuman Tabel ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 px-3" }, null, -1)
const _hoisted_15 = { class: "col-7 px-3 row" }
const _hoisted_16 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Semua Transaksi", -1)
const _hoisted_18 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_19 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Belum Bayar", -1)
const _hoisted_21 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_22 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Sudah Bayar", -1)
const _hoisted_24 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, null, -1)
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "row align-items-start" }
const _hoisted_28 = { class: "col-1" }
const _hoisted_29 = {
  key: 0,
  class: "col-sm-7"
}
const _hoisted_30 = { class: "fv-row mb-6 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Pilih Sekolah", -1)
const _hoisted_32 = {
  key: 1,
  class: "col-2"
}
const _hoisted_33 = { class: "fv-row mb-6 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Tanggal Awal", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_36 = {
  key: 2,
  class: "col-2"
}
const _hoisted_37 = { class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, "Tanggal Akhir", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_40 = { class: "col-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, null, -1)
const _hoisted_42 = { class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_43 = { class: "card-body py-3" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Bayar"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Referensi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Executor"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "text-left" }
const _hoisted_49 = { class: "text-left" }
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = { class: "text-left" }
const _hoisted_52 = {
  key: 0,
  class: "text-left"
}
const _hoisted_53 = {
  key: 1,
  class: "text-left"
}
const _hoisted_54 = {
  key: 2,
  class: "text-left"
}
const _hoisted_55 = { class: "text-left" }
const _hoisted_56 = { class: "text-left" }
const _hoisted_57 = { class: "text-left" }
const _hoisted_58 = { class: "text-left" }
const _hoisted_59 = { class: "text-center" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "row mt-5 mb-5" }
const _hoisted_67 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_68 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_69 = ["label", "value"]
const _hoisted_70 = { class: "p-3" }
const _hoisted_71 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_72 = { class: "pagination" }
const _hoisted_73 = { class: "row mt-5 mb-5" }
const _hoisted_74 = ["validation-schema"]
const _hoisted_75 = { class: "modal-dialog modal-md" }
const _hoisted_76 = { class: "modal-content" }
const _hoisted_77 = { class: "modal-header" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Detail Pembayaran ", -1)
const _hoisted_79 = { class: "svg-icon svg-icon-2x" }
const _hoisted_80 = { class: "modal-body row pt-2" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-lg-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nomor Referensi ")
], -1)
const _hoisted_84 = { class: "col-lg-12" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Eksekutor ")
], -1)
const _hoisted_86 = { class: "col-lg-12" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Penanggung Jawab ")
], -1)
const _hoisted_88 = { class: "col-lg-12" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nama Rekening Pengirim ")
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Bukti Transfer ")
  ])
], -1)
const _hoisted_91 = { class: "col-lg-12" }
const _hoisted_92 = ["src"]
const _hoisted_93 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, "History Pembayaran " + _toDisplayString(_ctx.metodePembayaran), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", {
                  class: "nav-link active fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                  "data-bs-toggle": "tab",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeAll && _ctx.changeAll(...args))),
                  style: {"cursor":"pointer"}
                }, "Semua")
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createElementVNode("a", {
                  class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                  "data-bs-toggle": "tab",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeOtomatis && _ctx.changeOtomatis(...args))),
                  style: {"cursor":"pointer"}
                }, "Pembayaran Otomatis")
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("a", {
                  class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                  "data-bs-toggle": "tab",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeManual && _ctx.changeManual(...args))),
                  style: {"cursor":"pointer"}
                }, "Pembayaran Manual")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("p", _hoisted_18, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.totalInvoice)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.totalUnPaid)), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("p", _hoisted_24, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.totalPaid)), 1)
          ]),
          _hoisted_25
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-light",
              style: {"font-weight":"400","margin-top":"20px"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
            }, " Filter ")
          ]),
          (_ctx.showFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.schoolId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schoolId) = $event)),
                    placeholder: "Pilih Sekolah",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.listSekolah,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pilihSekolah($event)))
                  }, null, 8, ["modelValue", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.dateFrom,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateFrom) = $event)),
                    clearable: false,
                    type: "text",
                    name: "dateFrom",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pilihTanggalAwal()))
                  }, null, 8, ["modelValue"]),
                  _hoisted_35
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.dateUntil,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dateUntil) = $event)),
                    clearable: false,
                    type: "text",
                    name: "dateUntil",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pilihTanggalAkhir()))
                  }, null, 8, ["modelValue"]),
                  _hoisted_39
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                class: "btn btn-md btn-primary"
              }, " Download ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("table", _hoisted_45, [
            _hoisted_46,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_48, _toDisplayString(item.number), 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(item.title), 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.date(item.invoiceDate)), 1),
                      _createElementVNode("td", _hoisted_51, " Rp. " + _toDisplayString(_ctx.formatPrice(item.totalAmount)), 1),
                      (item.paymentStatus === 'ACCEPT')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_52, " Diterima "))
                        : (item.paymentStatus === 'WAIT')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_53, " Menunggu Konfirmasi "))
                          : (_openBlock(), _createElementBlock("td", _hoisted_54, "Ditolak")),
                      _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.date(item.paymentDate)), 1),
                      _createElementVNode("td", _hoisted_56, _toDisplayString(item.refNumber), 1),
                      _createElementVNode("td", _hoisted_57, _toDisplayString(item.pic), 1),
                      _createElementVNode("td", _hoisted_58, _toDisplayString(item.executor), 1),
                      _createElementVNode("td", _hoisted_59, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_image",
                          onClick: ($event: any) => (_ctx.detailItem(item))
                        }, _hoisted_62, 8, _hoisted_60)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_63, _hoisted_65))
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_69))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("ul", _hoisted_72, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", {
          class: "modal fade",
          tabindex: "-1",
          id: "kt_modal_image",
          "validation-schema": _ctx.selectBank
        }, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", {
                  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clickReset && _ctx.clickReset(...args))),
                  "aria-label": "Close"
                }, [
                  _createElementVNode("span", _hoisted_79, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "noRef",
                      class: "form-control form-control-lg",
                      placeholder: "",
                      disabled: "",
                      modelValue: _ctx.detailShow.noRef,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detailShow.noRef) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "noRef",
                      class: "form-control form-control-lg",
                      placeholder: "",
                      disabled: "",
                      modelValue: _ctx.detailShow.executor,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detailShow.executor) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "noRef",
                      class: "form-control form-control-lg",
                      placeholder: "",
                      disabled: "",
                      modelValue: _ctx.detailShow.penanggungJawab,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detailShow.penanggungJawab) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "noRef",
                      class: "form-control form-control-lg",
                      placeholder: "",
                      disabled: "",
                      modelValue: _ctx.detailShow.bankNameSender,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.detailShow.bankNameSender) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_90,
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("img", {
                      alt: "filebuktitransfer",
                      class: "pl-3 col-lg-12",
                      style: {"max-width":"400px"},
                      src: _ctx.detailShow.imageShow
                    }, null, 8, _hoisted_92)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("button", {
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.clickReset && _ctx.clickReset(...args))),
                  type: "button",
                  class: "btn btn-danger",
                  "data-bs-dismiss": "modal"
                }, " Oke ")
              ])
            ])
          ])
        ], 8, _hoisted_74)
      ])
    ], 2)
  ], 64))
}